import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import Head from "@/components/Head/index.vue";
import Tabs from "@/components/Tabs/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, onActivated, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "Integral",
  components: {
    Head: Head,
    Pagination: Pagination,
    Tabs: Tabs
  },
  setup: function setup() {
    var titleArr = ["今日积分", "积分记录"];
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var keepStatus = true; //首次进入为缓存状态，但不需要走activited方法
    //获得当天时间

    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var months = month < 10 ? "0".concat(month) : month;
    var day = date.getDate();
    var dates = day < 10 ? "0".concat(day) : day; //选择时间

    var Data = reactive({
      value1: "",
      value2: "",
      score: {},
      time: ""
    }); // 表格加载

    var loading = ref(false);
    var tableloading = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_tableloading;
    Data.time = "".concat(year, "-").concat(months, "-").concat(dates); // 第一个table的初始化

    var tableData = ref([{}]);
    var totalNum = ref(0);
    var pageIndex = ref(1); // 获取表一

    function getTableOne() {
      return _getTableOne.apply(this, arguments);
    }

    function _getTableOne() {
      _getTableOne = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                loading.value = true;
                _context3.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["scoreToday"]();

              case 3:
                _yield$globalProperti = _context3.sent;
                data = _yield$globalProperti.data;
                tableData.value = _toConsumableArray(data);
                loading.value = false;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getTableOne.apply(this, arguments);
    }

    function changPage(val) {
      pageIndex.value = val;
      getTableOne();
    } // 第二个table初始化


    var tableDataTwo = ref([{}]);
    var totalNumTwo = ref(0);
    var pageIndexTwo = ref(1);

    function getTableTwo() {
      return _getTableTwo.apply(this, arguments);
    }

    function _getTableTwo() {
      _getTableTwo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$globalProperti2, data, total;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                loading.value = true;
                _context4.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getIntegralList"]({
                  pageIndex: pageIndexTwo.value,
                  time: Data.time
                });

              case 3:
                _yield$globalProperti2 = _context4.sent;
                data = _yield$globalProperti2.data;
                total = _yield$globalProperti2.total;
                tableDataTwo.value = _toConsumableArray(data);
                totalNumTwo.value = total;
                loading.value = false;

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _getTableTwo.apply(this, arguments);
    }

    function changPageTwo(val) {
      pageIndexTwo.value = val;
      getTableTwo();
    } //个人积分值


    function mySort() {
      return _mySort.apply(this, arguments);
    } //新增积分值


    function _mySort() {
      _mySort = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _yield$globalProperti3, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getmyScore"]();

              case 2:
                _yield$globalProperti3 = _context5.sent;
                data = _yield$globalProperti3.data;
                Data.score = _objectSpread({}, data);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _mySort.apply(this, arguments);
    }

    function addmySort(_x) {
      return _addmySort.apply(this, arguments);
    } //查看排行


    function _addmySort() {
      _addmySort = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(item) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (item.typeName == "资料下载") {
                  router.push({
                    name: "multiColumn",
                    query: {
                      stair: 3,
                      son: 2
                    }
                  });
                } else if (item.typeName == "三会一课") {
                  router.push({
                    name: "multiColumn",
                    query: {
                      stair: 1,
                      son: 2
                    }
                  });
                } else if (item.typeName == "两学一做") {
                  router.push({
                    name: "multiColumn",
                    query: {
                      stair: 1,
                      son: 1
                    }
                  });
                } else if (item.typeName == "规章制度") {
                  router.push({
                    name: "multiColumn",
                    query: {
                      stair: 3,
                      son: 1
                    }
                  });
                } else if (item.typeName == "困难帮扶") {
                  router.push({
                    name: "multiColumn",
                    query: {
                      stair: 3,
                      son: 3
                    }
                  });
                } else if (item.typeName == "表彰与处分") {
                  router.push({
                    name: "multiColumn",
                    query: {
                      stair: 2,
                      son: 1
                    }
                  });
                } else if (item.typeName == "收藏") {
                  router.push({
                    name: "multiColumn",
                    query: {
                      stair: 1,
                      son: 1
                    }
                  });
                } else if (item.typeName == "考试") {
                  router.push({
                    name: "ExamIndex"
                  });
                } else if (item.typeName == "新闻") {
                  router.push({
                    name: "index"
                  });
                } else if (item.typeName == "调查问卷") {
                  router.push({
                    name: "questionnaire"
                  });
                } else if (item.typeName == "思想摸排") {
                  router.push({
                    name: "thought"
                  });
                } else if (item.typeName == "工作计划与总结") {
                  router.push({
                    name: "workPlan"
                  });
                } else if (item.typeName == "网上投票") {
                  router.push({
                    name: "investigate"
                  });
                } else if (item.typeName == "年度考核") {
                  router.push({
                    name: "AnnualCheck"
                  });
                } else if (item.typeName == "民主评议") {
                  router.push({
                    name: "Democracy"
                  });
                }

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _addmySort.apply(this, arguments);
    }

    var Rank = function Rank() {
      router.push({
        name: "integralRank"
      });
    };

    getTableOne();
    getTableTwo();
    mySort();
    watch(function () {
      return Data.value1;
    }, function () {
      getMyData();
    });
    watch(function () {
      return Data.value2;
    }, function () {
      getMyMonth();
    }); //选择时间

    var getMyData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var month, months, date, dates, searchTime;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                month = Data.value1.getMonth() + 1;
                months = month < 10 ? "0".concat(month) : month;
                date = Data.value1.getDate();
                dates = date < 10 ? "0".concat(date) : date;
                searchTime = "".concat(Data.value1.getFullYear(), "-").concat(months, "-").concat(dates);
                Data.time = searchTime;
                getTableTwo();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getMyData() {
        return _ref.apply(this, arguments);
      };
    }();

    var getMyMonth = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var month, months, searchTime;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                month = Data.value2.getMonth() + 1;
                months = month < 10 ? "0".concat(month) : month;
                searchTime = "".concat(Data.value2.getFullYear(), "-").concat(months);
                Data.time = searchTime;
                getTableTwo();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getMyMonth() {
        return _ref2.apply(this, arguments);
      };
    }(); // 页面激活钩子函数


    onActivated(function () {
      // 重新加载
      if (!keepStatus) {
        getTableOne();
        getTableTwo();
      } else {
        keepStatus = false;
      }
    }); //table切换事件

    var flag = ref(0);

    function changeOther(val) {
      flag.value = val;
    }

    return {
      tableloading: tableloading,
      loading: loading,
      titleArr: titleArr,
      tableData: tableData,
      totalNum: totalNum,
      pageIndex: pageIndex,
      changPage: changPage,
      tableDataTwo: tableDataTwo,
      totalNumTwo: totalNumTwo,
      pageIndexTwo: pageIndexTwo,
      changPageTwo: changPageTwo,
      changeOther: changeOther,
      mySort: mySort,
      flag: flag,
      Data: Data,
      Rank: Rank,
      getMyMonth: getMyMonth,
      addmySort: addmySort
    };
  }
});